import { useEffect } from 'react';
import useAuth from '../Services/useAuth';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAdmin }) => {
  const { getUser, token, isTokenExpired, setToken, setRole } = useAuth();
  const navigate = useNavigate();
  const user = getUser();
  const isAuthenticated = Boolean(token && user && !isTokenExpired());
  const hasRequiredRole = +user?.is_admin === +isAdmin;

  useEffect(() => {
    if (!isAuthenticated) {
      setToken(null);
      setRole('');
      navigate('/', { replace: true });
      return;
    }

    if (!hasRequiredRole) {
      navigate('/route-violation', { replace: true });
    }
  }, [isAuthenticated, hasRequiredRole, navigate, setToken, setRole]);

  return isAuthenticated && hasRequiredRole ? children : null;
};

export default ProtectedRoute;
